import { ProfileSearchSvg } from '@/assets/icons/profile-search-svg';
import { cn } from '@/lib/cn';
import { TypographyPBold } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';

export const SessionsListAssistantView = () => {
  const { t } = useTranslations();

  return (
    <div className="h-full" data-testid="sessions-list-assistant-view">
      <div className={cn('flex h-full flex-col gap-2 rounded-md')}>
        <div
          className={cn(
            'flex flex-auto flex-col items-center justify-center gap-4 overflow-x-hidden'
          )}
        >
          <ProfileSearchSvg size={56} />
          <TypographyPBold className="text-center">
            {t('sessions.selectClinicianToViewSessions')}
          </TypographyPBold>
        </div>
      </div>
    </div>
  );
};
